import { motion } from 'framer-motion';
import styles from './HeaderMenuMobile.module.css';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { ReactComponent as LanguagesSvg } from "../../../assets/icons/languages.svg";
import { LanguagePicker } from '../../common/components/LanguagePicker';

export const HeaderMenuMobile = ({ onClick }: { onClick: () => void }) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        console.log('i18n.language: ', i18n.language)
    }, [i18n.language])

    return (
        <motion.div
            className={styles.headerLabelWrapper}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            style={{ overflow: 'hidden' }}
        >
            <NavLink
                to="/#events"
                onClick={onClick}
                className={styles.headerLabel}
            >
                {t('header.tabs.events')}
            </NavLink>
            <div className={styles.divider} />
            {/*
            <NavLink
                to="/about"
                onClick={onClick}
                className={styles.headerLabel}
            >
                {t('header.tabs.about')}
            </NavLink>
            <div className={styles.divider} />
            */}
            <NavLink
                to="/contact"
                onClick={onClick}
                className={styles.headerLabel}
            >
                {t('header.tabs.contact')}
            </NavLink>

            <div className={styles.divider} />

            <LanguagePicker
                trigger={({ currentLang, isOpen, toggle, ref }) => (
                    <button ref={ref} className={styles.langSelector} onClick={toggle}>
                        <LanguagesSvg width={24} height={24} />
                        <span>{currentLang.label}</span>
                        <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>▾</span>
                    </button>
                )}
            />
        </motion.div>
    );
};